// Единый формат сумм по всей диспетчерской — округление до целого рубля (копейки в ценах
// на работы не используются), чтобы одна и та же сумма не выглядела по-разному на разных
// вкладках (было одновременно и "1 500 ₽", и "1 500,00 ₽" за один и тот же акт)
export function formatMoney(value?: string | number | null, emptyLabel = '0 ₽'): string {
  if (value === undefined || value === null || value === '') return emptyLabel;
  return `${Math.round(Number(value)).toLocaleString('ru-RU')} ₽`;
}

// Для зарплатной ведомости округление до рубля не годится: заработок — это доля от суммы
// работ (например 35% от 1 234 ₽ = 431,90 ₽), и округлённые строки перестают складываться
// в округлённый итог. Копейки показываем только когда они есть, чтобы ровные суммы
// не выглядели как "8 500,00 ₽" в таблице из тридцати строк
export function formatMoneyPrecise(value: number, emptyLabel = '0 ₽'): string {
  if (!Number.isFinite(value)) return emptyLabel;
  const hasKopecks = Math.round(value * 100) % 100 !== 0;
  return `${value.toLocaleString('ru-RU', {
    minimumFractionDigits: hasKopecks ? 2 : 0,
    maximumFractionDigits: 2,
  })} ₽`;
}
